import * as axios from 'axios';
import Store from '@/store';

/** ************************************************************************* */
function createRequester() {
  const AXIOS = axios.default.create({
    headers: {
      Accept: 'application/json',
      'Cache-Control': 'no-cache, no-store',
      'Content-Type': 'application/json',
      'X-ACCESS-TOKEN': Store.state.token,
    },
  });
  return AXIOS;
}

function createRequesterMultiByte() {
  const AXIOS = axios.default.create({
    headers: {
      'X-ACCESS-TOKEN': Store.state.token
    },
  });
  return AXIOS;
}
/** ************************************************************************* */
/** APIのエラーをハンドルする */
function handleErrors(error: any) {
  endApi();
  if(error.response === undefined || error.response === null ||
    error.response.data === undefined || error.response.data === null) {
    const event = new ErrorEvent('unhandledrejection', {
      error: error,
    });
    self.dispatchEvent(event);
    return;
  }

  let count = 0;
  for (const v of error.response.data.errors) {
    v['key'] = ++count;
  }
  const event = new ErrorEvent('error', {
    error: error.response.data.errors,
  });
  self.dispatchEvent(event);
}

/** ローディング開始 */
function startApi() {
  const event = new Event('startLoading', {});
  self.dispatchEvent(event);
}
/** ローディング終了 */
function endApi() {
  const event = new Event('endLoading', {});
  self.dispatchEvent(event);
}

/** 環境毎のendpointを取得 */
function endpoint() {
  return process.env.VUE_APP_API_ORIGIN;
}
/** ********************************************************************************* */
/**
 * ログインする
 * @param loginId  ログインID
 * @param password パスワード
 * @param successCallback ログイン成功時のコールバック(レスポンス)
 * @param errorCallback ログイン失敗時のコールバック(引数無し)
 */
export function login(loginId: string, password: string, successCallback: any, errorCallback: any) {
  try{
    // startApi();
    createRequester().post(endpoint() + '/v1/login', {
      'loginId': loginId,
      'password': password
    })
    .then((response) => successCallback(response.data))
    // .then(() => endApi())
    .catch((error) => errorCallback(error));
  } catch(error) {
    errorCallback();
  }
}

/**
 * ログアウトする
 */
export function logout(loginId: string, callback: any) {
  startApi();
  createRequester().post(endpoint() + '/v1/exception/logout', {
    'loginId': loginId
  })
  .then((response) => callback(response.data))
  .then(() => endApi())
  .catch((error) => handleErrors(error));
}

// /** 入庫状況を取得する */
// export function getInboundConfirmations(account: string, callback: any) {
//   startApi();
//   createRequester().get(endpoint() + '/v1/inbondstatus/list', {
//     params: {
//       'account': account
//     }
//   })
//   .then((response) => callback(response.data))
//   .then(() => endApi())
//   .catch((error) => handleErrors(error));
// }

/** 収支サマリリストを取得する */
export function getInoutSummaryList(account: string, callback: any) {
  startApi();
  createRequester().post(endpoint() + '/v1/inout/list', {
    'account': account
  })
  .then((response) => callback(response.data))
  .then(() => endApi())
  .catch((error) => handleErrors(error));
}

/** 収支明細をアップロードする（CSV） */
export function uploadInoutSummaryCsv(formData: any, callback: any) {
  startApi();
  createRequesterMultiByte().post(endpoint() + '/v1/inout/uploadcsv', formData)
  .then((response) => callback(response.data))
  .then(() => endApi())
  .catch((error) => handleErrors(error));
}

/** 収支明細をアップロードする（PDF） */
export function uploadInoutSummaryPdf(formData: any, callback: any) {
  startApi();
  createRequesterMultiByte().post(endpoint() + '/v1/inout/uploadpdf', formData)
  .then((response) => callback(response.data))
  .then(() => endApi())
  .catch((error) => handleErrors(error));
}

